import NotInterestedIcon from '@mui/icons-material/NotInterested';
import { Box, Typography, Stack } from '@mui/material';
import { Question } from '@/types/slide';
import { ResultContainer, ResultContent, ResultTitle } from '../ResultCard';
import { useTranslation } from 'react-i18next';

export const ResultCardUnsupported: React.FC<{ question: Question }> = ({ question }) => {
    const { t } = useTranslation();

    return (
        <ResultContainer>
            <Stack spacing={1} sx={{}}>
                <ResultTitle variant='h6'>
                    {t('common.unsupported')} ({question.type})
                </ResultTitle>

                {/* padding  */}
                <Box sx={{ gap: 4 }}>
                    <Typography>{'\u00A0'}</Typography>
                </Box>
            </Stack>
            <ResultContent>
                <NotInterestedIcon sx={{ fontSize: 200, color: (theme) => (theme.vars || theme).palette.error.main, m: 5 }} />
            </ResultContent>
        </ResultContainer>
    );
};
